import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTime } from "luxon";
import CalendarIcon from "@mui/icons-material/Event";
import { notBlank } from "../../util/ext";

const useStyles = marginTop =>
  makeStyles(theme => ({
    root: {
      marginTop: marginTop,
    },

    input: {
      marginTop: 16,
    },
  }));

const DatePicker = props => {
  const {
    onChange,
    value,
    required = false,
    noLabel = false,
    label = "Publication Date",
    placeholder,
    marginTop = 10,
  } = props;
  const classes = useStyles(marginTop)();

  return (
    <MuiDatePicker
      format="MM/dd/yyyy"
      minDate={DateTime.fromISO("1000-01-01")}
      label={noLabel ? null : label}
      value={notBlank(value) ? DateTime.fromISO(value).setZone("utc") : null}
      onChange={onChange}
      slots={{ openPickerIcon: CalendarIcon }}
      slotProps={{
        openPickerIcon: { fontSize: "small" },
        openPickerButton: { "aria-label": "change date" },
        textField: {
          className: classes.root,
          margin: "none",
          fullWidth: true,
          required: required,
          id: "date-picker-inline",
          placeholder: placeholder,
          InputProps: noLabel ? { classes: { root: classes.input } } : {},
        },
      }}
    />
  );
};

export default DatePicker;
